// src/utils/profissoesCBO.js

export const PROFISSOES_CBO = [
  "Administrador", "Advogado", "Açougueiro", "Agente de Viagens", "Agrônomo",
  "Almoxarife", "Analista de Banco de Dados", "Analista de Marketing", 
  "Analista de Recursos Humanos", "Analista de Sistemas", "Analista Financeiro",
  "Aposentado", "Arquiteto", "Assistente Administrativo", "Assistente Social",
  "Atendente de Telemarketing", "Ator/Atriz", "Auditor", "Autônomo", "Babá",
  "Bancário", "Barbeiro", "Biomédico", "Biólogo", "Bombeiro", "Borracheiro",
  "Cabeleireiro", "Caixa", "Caminhoneiro", "Cantor", "Carpinteiro", "Carteiro",
  "Cientista de Dados", "Cineasta", "Cirurgião", "Comerciante", "Comissário de Bordo",
  "Confeiteiro", "Consultor de Vendas", "Contador", "Corretor de Imóveis",
  "Corretor de Seguros", "Costureiro", "Cozinheiro", "Delegado", "Dentista",
  "Designer de Interiores", "Designer Gráfico", "Desenvolvedor", "Diretor",
  "Do Lar", "Economista", "Eletricista", "Empresário", "Encanador", "Enfermeiro",
  "Engenheiro Agrônomo", "Engenheiro Civil", "Engenheiro de Produção", 
  "Engenheiro de Software", "Engenheiro Elétrico", "Engenheiro Mecânico",
  "Escritor", "Esteticista", "Estudante", "Farmacêutico", "Faturista", 
  "Fisioterapeuta", "Fonoaudiólogo", "Fotógrafo", "Frentista", "Garçom",
  "Geógrafo", "Geólogo", "Gerente de Loja", "Gerente de Projetos", "Gestor",
  "Guarda Municipal", "Historiador", "Inspetor", "Jardineiro", "Jornalista",
  "Juiz", "Locutor", "Manicure", "Maquiador", "Marceneiro", "Marinheiro",
  "Matemático", "Mecânico", "Médico", "Mergulhador", "Militar", "Modelo",
  "Motorista de Aplicativo", "Motorista de Ônibus", "Músico", "Nutricionista",
  "Odontologista", "Operador de Caixa", "Operador de Máquinas", "Padeiro",
  "Pedagogo", "Pedreiro", "Pensionista", "Personal Trainer", "Pescador",
  "Piloto", "Pintor", "Policial Civil", "Policial Federal", "Policial Militar",
  "Porteiro", "Professor", "Programador", "Promotor", "Psicanalista", 
  "Psicólogo", "Psiquiatra", "Publicitário", "Químico", "Radialista", 
  "Recepcionista", "Representante Comercial", "Relações Públicas", "Sacerdote",
  "Secretário", "Segurança", "Serralheiro", "Servidor Público", "Sociólogo",
  "Soldador", "Supervisor", "Tatuador", "Taxista", "Técnico de Informática",
  "Técnico de Segurança do Trabalho", "Técnico em Enfermagem", "Topógrafo",
  "Tradutor", "Vendedor", "Veterinário", "Vigilante", "Zootecnista", "Outros"
].sort(); // O .sort() já garante que a lista nasça em ordem alfabética